<data-table [rowData]="products" [pageData]="pages" [columnData]="columnData" />